<template>
    <v-container grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12 md6>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs6>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light">Customers COD ({{ $format.int(pager.totalRecords) }})</h1>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout align-center justify-end row fill-height>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="toggleSearchAt">
                                            <v-icon>{{ searchAt.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Match search text at this position</span>
                                </v-tooltip>
                                <v-text-field ref="search" v-model="searchText" placeholder="Type here to filter" :hint="`(${searchAt.text}) Acc No, Customer`" persistent-hint prepend-icon="search" clearable @keyup.native="searchChange" @click:clear="searchChange"></v-text-field>
                                <!-- <v-text-field v-model="searchText" append-icon="search" @keyup.native="searchChange" @click:clear="searchChange"></v-text-field> -->
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-card>
                                <v-data-table :headers="headers" :items="tableData" :loading="isBusy" hide-actions>
                                    <template slot="items" slot-scope="props">
                                        <tr @click="onSelect(props.item)" :class="(props.item.SN_STOP ? 'red-grid-row' : '') + (props.item.xSel ? ' primary white--text' : '')">
                                            <td>
                                                <div>{{ props.item.SN_ACCOUNT }}</div>
                                                <div class="f-m opa-6">{{ props.item.SN_ANALSYS }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.SN_NAME }}</div>
                                                <div class="f-m opa-6">{{ props.item.SN_CONTACT }} {{ props.item.SN_TELENO }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.SN_CUSTYPE }}</div>
                                                <div class="f-m opa-6">&nbsp;</div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left">
                                        <v-pagination v-model="pager.currentPage" :length="pager.pages" :total-visible="5" @next="loadData" @previous="loadData" @input="loadData"></v-pagination>
                                    </div>
                                    <div class="pb-1 pl-2 el-float-right">
                                        <v-select v-model="pager.pageSize" :items="pageSizes" label="Page Size" dense hide-details style="max-width:80px;" @change="loadData"></v-select>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
            <v-flex xs12 md6>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs8>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light">{{ selected.SN_NAME }}</h1>
                            </v-layout>
                        </v-flex>
                        <v-flex xs4>
                            <v-layout align-center justify-end row fill-height>
                                <v-btn icon disabled><v-icon>business</v-icon></v-btn><!-- fingerprint -->
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-card class="mx-auto">
                                <v-card-text>
                                    <v-container grid-list-sm class="pa-0">
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <!-- <v-text-field ref="codAccount" label="Account Number" v-model="selected.SN_ACCOUNT" :rules="[rules.required]"></v-text-field> -->
                                                <v-select ref="codAccount" label="Account Number" v-model="selected.SN_ACCOUNT" data-field="SN_ACCOUNT" :items="accounts" item-text="SN_NAME" item-value="SN_ACCOUNT" :rules="[rules.required]" @focus="onInputFocus" @blur="onInputBlur"></v-select>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field label="Customer Name" v-model="selected.SN_NAME" data-field="SN_NAME" :rules="[rules.required]" @focus="onInputFocus" @blur="onInputBlur"></v-text-field>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-text-field label="Contact" v-model="selected.SN_CONTACT" data-field="SN_CONTACT" @focus="onInputFocus" @blur="onInputBlur"></v-text-field>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-text-field label="Email" v-model="selected.SN_EMAIL" data-field="SN_EMAIL" @focus="onInputFocus" @blur="onInputBlur"></v-text-field>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-text-field label="Phone Number" v-model="selected.SN_TELENO" data-field="SN_TELENO" :rules="[rules.required, rules.phoneCount]" @focus="onInputFocus" @blur="onInputBlur"></v-text-field>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-text-field label="Fax Number" v-model="selected.SN_FAXNO" data-field="SN_FAXNO" @focus="onInputFocus" @blur="onInputBlur"></v-text-field>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-text-field label="VAT Number" v-model="selected.SN_DADDR5" data-field="SN_DADDR5" @focus="onInputFocus" @blur="onInputBlur"></v-text-field>
                                            </v-flex>
                                            <!-- <v-flex xs6>
                                                <v-text-field label="Reference" v-model="selected.Ref"></v-text-field>
                                            </v-flex> -->
                                            <v-flex xs12 class="qx-cod-note">
                                                <div class="caption grey--text text--darken-1">Comment</div>
                                                <quill-editor v-model="selected.SN_MEMO" data-field="SN_MEMO" ref="richCODComment" :options="editorOption" @focus="onInputFocus" @blur="onInputBlur"></quill-editor>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn class="ma-0" small v-if="hasCustomer" @click="onNewQuote" :loading="isSaving">New Quote</v-btn>
                            <v-btn class="ma-0" small v-if="hasCustomer" disabled>Send Email</v-btn>
                            <v-btn class="ma-0 el-float-right" small v-if="hasCustomer" @click="onNewCustomer">New Customer</v-btn>
                            <v-btn class="ma-0" small v-if="!hasCustomer" @click="onCustomerAdd" :loading="isAddBusy">Save &amp; Quote</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import Constants from '../../util/Constants';

export default {
    name: 'CustomersCOD',
    components: {
        quillEditor
    },
    data() {
        return {
            title: 'Customers',
            isBusy: false,
            isAddBusy: false,
            isSaving: false,
            user: { has: () => 0 },
            ViewCompany: {},
            searchText: '',
            searchOptions: Constants.SEARCH_OPTIONS,
            searchAt: {},
            searchAtOptions: Constants.SEARCH_AT_OPTIONS,
            hasCustomer: false,
            selected: {},
            headers: [
                { text: 'Account', value: 'SN_ACCOUNT', align: 'left', width: '100px', sortable: false },
                { text: 'Customer Name', value: 'SN_NAME', align: 'left', sortable: true },
                { text: 'Type', value: 'SN_CUSTYPE', align: 'left', width: '100px', sortable: true },
            ],
            tableData: [],
            pageSizes: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100],
            pager: {
                pageSize: 20,
                currentPage: 1,
                pages: 1,
                totalRecords: 0
            },
            accounts: [],
            editorOption: {
                modules: {
                    toolbar: [
                        [{ size: ['small', false, 'large', 'huge'] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ color: [] }, { background: [] }, 'clean']
                    ]
                }
            },
            rules: {
                required: value => !!value || 'Required.',
                phoneCount: value => ((value && value.length) >= 10 && (value && value.length) <= 12) || 'Invalid number.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || 'Invalid e-mail.';
                }
            },
        };
    },
    mounted() {
        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.pager.pageSize = this.$ls.get('PageSize_Cust', 20);
        this.showTitles = this.$ls.get('InfoTitles', true);
        this.searchAt = this.searchAtOptions[0];
        this.loadData();
        setTimeout(() => this.$refs.codAccount.focus(), 250); // search
    },
    methods: {
        async loadData() {
            try {
                this.isBusy = true;
                this.searchText = this.searchText || '';
                const accs = await this.$http.post('/CustomerCOD/accounts');
                this.accounts = accs.data.d;
                const response = await this.$http.post('/CustomerCOD/list', { search: this.searchText.trim(), searchAt: this.searchAt.value, C_Id: this.ViewCompany._id, _page: { per: this.pager.pageSize, page: this.pager.currentPage } });
                this.pager.totalRecords = response.data.p.t;
                this.pager.pages = response.data.p.pt;
                const d = response.data.d;
                this.tableData = d;
                if (this.ContextCustomer._id) {
                    const ccust = this.ContextCustomer;
                    const cust = this.tableData.find(o => o._id === ccust._id);
                    if (cust) {
                        this.onSelect(cust);
                    }
                }
                else {
                    this.selected = { SN_ACCOUNT: 'CO102' };
                }
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        toggleSearchAt() {
            let pos = this.searchAtOptions.indexOf(this.searchAt);
            pos += 1;
            if (pos === this.searchAtOptions.length) pos = 0;
            this.searchAt = this.searchAtOptions[pos];
            if (this.searchText.trim().length) this.loadData();
            this.$refs.search.focus();
        },
        searchChange() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.pager.currentPage = 1;
                this.loadData();
            }, 600);
        },
        onSelect(row) {
            if (!row) return;
            // this.$router.push({ name: 'CustomerDetail', params: row._id });
            // this.$router.push({ name: 'CustomerDetail', query: { id: row._id } });
            /* let list;
            if (!row.Physical) {
                list = [];
                if (row.SN_DADDR1) list.push(row.SN_DADDR1);
                if (row.SN_DADDR2) list.push(row.SN_DADDR2);
                if (row.SN_DADDR3) list.push(row.SN_DADDR3);
                if (row.SN_DADDR4) list.push(row.SN_DADDR4);
                if (row.SN_DPSTCO) list.push(row.SN_DPSTCO);
                row.Physical = list;
            }
            if (!row.Postal) {
                list = [];
                if (row.SN_ADDR1) list.push(row.SN_ADDR1);
                if (row.SN_ADDR2) list.push(row.SN_ADDR2);
                if (row.SN_ADDR3) list.push(row.SN_ADDR3);
                if (row.SN_ADDR4) list.push(row.SN_ADDR4);
                if (row.SN_PSTCODE) list.push(row.SN_PSTCODE);
                row.Postal = list;
            } */
            const curSel = this.tableData.find(o => o.xSel === true);
            if (curSel) curSel.xSel = false;
            row.xSel = true;
            this.hasCustomer = true;
            this.selected = row;
            this.$customer(this.selected);
        },
        /* addNew() {
            this.$router.push({ name: 'CustomerDetail', query: { id: '' } });
        } */
        onNewQuote() {
            this.$router.push({ name: 'Quote' });
        },
        onNewCustomer() {
            this.hasCustomer = false;
            this.selected = { SN_ACCOUNT: 'CO102' };
            this.$refs.codAccount.focus();
        },
        async onCustomerAdd() {
            if (!this.selected.SN_ACCOUNT || this.selected.SN_ACCOUNT.trim() === '' ||
                !this.selected.SN_NAME || this.selected.SN_NAME.trim() === '' ||
                !this.selected.SN_TELENO || this.selected.SN_TELENO.trim() === '') {
                this.$alert({ type: 'warning', title: 'Missing Detail', message: 'Please an account number, customer name and phone number before saving.' });
                return;
            }
            /* selected.SN_CONTACT
            selected.SN_EMAIL
            selected.SN_FAXNO
            selected.SN_DADDR5
            selected.Ref
            selected.SN_MEMO */

            this.isAddBusy = true;
            try {
                this.selected.C_Id = this.ViewCompany._id;
                const response = await this.$http.post('/CustomerCOD', this.selected);
                if (!response.data.s) {
                    this.$alert({ type: 'error', title: 'Create Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                    return;
                }
                // console.warn(response.data.d);
                // this.loadData();
                this.$customer(this.selected);
                this.onNewQuote();
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Create Error', message: `An error occurred trying to save the data. ${err.message}` });
            }
            this.isAddBusy = false;
        },
        onInputFocus(evt) {
            if (!this.selected) return;
            const elem = evt.srcElement
                ? evt.srcElement
                : evt.container;
            const field = evt.srcElement ? elem.dataset.field : 'SN_MEMO';
            const val = this.selected[field] === undefined || this.selected[field] === null ? '' : this.selected[field];
            elem.dataset.org = val;
        },
        async onInputBlur(evt) {
            if (!this.selected) return;
            if (!this.selected._id) return;
            const elem = evt.srcElement
                ? evt.srcElement
                : evt.container;
            const field = evt.srcElement ? elem.dataset.field : 'SN_MEMO';
            const org = elem.dataset.org === undefined || elem.dataset.org === null ? '' : elem.dataset.org;
            const val = this.selected[field] === undefined || this.selected[field] === null ? '' : this.selected[field];
            // Update the field in the DB.
            if (org !== val) { // There was a change.
                try {
                    this.isSaving = true;
                    const updateData = { _id: this.selected._id };
                    updateData[field] = val;
                    const response = await this.$http.post('/CustomerCOD/save', updateData);
                    if (!response.data.s) this.$alert({ type: 'error', title: 'Save Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                }
                catch (err) {
                    console.error(err);
                    this.$alert({ type: 'error', title: 'Save Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                }
                finally {
                    this.isSaving = false;
                }
            }
        }
    }
};
</script>

<style>
.qx-cod-note .quill-editor {
    height: 200px;
}
.qx-cod-note .ql-container {
    max-height: 160px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/CustomersCOD.vue